import { render, staticRenderFns } from "./ProjectChangeData.vue?vue&type=template&id=1be97660&scoped=true"
import script from "./ProjectChangeData.vue?vue&type=script&lang=js"
export * from "./ProjectChangeData.vue?vue&type=script&lang=js"
import style0 from "./ProjectChangeData.vue?vue&type=style&index=0&id=1be97660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be97660",
  null
  
)

export default component.exports